import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, PlayCircle } from "lucide-react";
import { Introduccion } from "@/components/intro/Introduccion";
import { InstalarMovil } from "@/components/intro/InstalarMovil";

export default function Bienvenida() {
  const navigate = useNavigate();
  const [intro, setIntro] = useState(false);
  const finIntro = (r) => { setIntro(false); if (r === "registro") navigate("/registro"); };

  return (
    <div className="min-h-screen bg-[#FAF8F5] px-5 flex flex-col" data-testid="bienvenida"
      style={{ paddingTop: "max(env(safe-area-inset-top), 2rem)", paddingBottom: "max(env(safe-area-inset-bottom), 1.5rem)" }}>
      <div className="w-full max-w-md mx-auto flex-1 flex flex-col justify-center">
        <header className="text-center">
          <span className="w-16 h-16 rounded-2xl bg-[#3A6B56] inline-flex items-center justify-center"><ShieldCheck size={34} className="text-white" /></span>
          <h1 className="font-heading text-4xl sm:text-5xl font-extrabold text-[#1C2421] tracking-tight mt-4" data-testid="bienvenida-titulo">AL DÍA <span className="text-[#3A6B56]">Fácil</span></h1>
          <p className="font-heading text-2xl font-bold text-[#3A6B56] mt-4 leading-snug" data-testid="bienvenida-subtitulo">Tu vida organizada, sin olvidos y en un solo lugar.</p>
          <p className="text-lg text-[#4A5550] mt-4 leading-relaxed" data-testid="bienvenida-texto">Organiza documentos, citas, planes, gastos y gestiones personales, y recibe avisos antes de que se te pase algo importante.</p>
        </header>

        <div className="mt-10 space-y-3">
          <button data-testid="bienvenida-ver-como-funciona" onClick={() => setIntro(true)} className="w-full min-h-[64px] rounded-2xl bg-[#3A6B56] text-white font-bold text-xl inline-flex items-center justify-center gap-2 shadow-lg shadow-[#3A6B56]/25 hover:bg-[#2E5645] transition-colors">
            <PlayCircle size={26} /> Ver cómo funciona
          </button>
          <button data-testid="bienvenida-crear-cuenta" onClick={() => navigate("/registro")} className="w-full min-h-[60px] rounded-2xl bg-white border-2 border-[#3A6B56] text-[#2E5645] font-bold text-xl hover:bg-[#E8F0EC] transition-colors">Crear mi cuenta</button>
          <button data-testid="bienvenida-ya-tengo-cuenta" onClick={() => navigate("/login")} className="w-full min-h-[52px] rounded-2xl text-[#1C2421] font-semibold text-lg hover:bg-[#F2EDE4] transition-colors">Ya tengo cuenta</button>
        </div>

        <div className="text-center mt-4"><InstalarMovil /></div>
      </div>
      {intro && <Introduccion publica onFin={finIntro} />}
    </div>
  );
}
